'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Left = require('./Left');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Left).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Arrows/light/Left/index.js
// module id = 1099
// module chunks = 1